//
// When they click on one of the predefined prompts,
// set the response prompt input to either the predefined prompt
// or whatever they've input into the custom-prompt field.

$(document).on("change", ".post-component input.response-prompt-selector", (e) => {
  const root = e.target.closest("div.post-component");
  const prompt = root.querySelector("input.response-prompt")

  if (e.target.checked) {
    if (e.target.value == "Custom") {
      prompt.value = root.querySelector("input.custom-prompt").value;
    } else {
      prompt.value = e.target.value;
    }
  }
});

//
// When they click on the custom prompt field, check the Custom radio button
//
$(document).on("focusin", ".post-component input.custom-prompt", (e) => {
  const root = e.target.closest("div.post-component");
  root.querySelector("input[type=radio][value='Custom']").click();
});

//
// When they edit the custom prompt field, update the response prompt input
//
$(document).on("input", ".post-component input.custom-prompt", (e) => {
  const root = e.target.closest("div.post-component");
  const prompt = root.querySelector("input.response-prompt");

  root.querySelector("input[type=radio][value='Custom']").click();
  prompt.value = root.querySelector("input.custom-prompt").value;
});

//
// Make the options sortable
//
$("div.post-component div.response-options").each((_,e) => {
  
  $(e).sortable({
    tolerance: "pointer",
    revert: "invalid",
    forceHelperSize: true,
    axis: "y",
    forcePlaceholderSize: true,
    handle: ".hamburger",
    placeholder: "list-group-item-success",
  });
})

$(document).on("click", "button.add-response", (e) => {
  const url = e.currentTarget.dataset.url;
  const root = e.currentTarget.closest("div.post-component");
  $.ajax({
    url: url,
    cache: false,
    success: (html) => {
      $(root.querySelector(".response-options")).append($(html));
    }
  });
});

$(document).on("click", ".response-option button.remove-response", (e) => {
  e.currentTarget.closest('.response-option').remove();
});